












































































import Vue, { PropOptions } from 'vue';
import { FaqItem } from '@/components/storyblok/FaqItem.vue';
import type { PaddingOptions } from '@/components/SectionContainer.vue';

export type FaqCategory = Blok & {
  title: string;
  items: FaqItem[];
  open?: boolean;
};

export type Faq = Blok & {
  id: string;
  title: string;
  categories: FaqCategory[];
  paddingTop?: PaddingOptions;
  paddingBottom?: PaddingOptions;
};

export default Vue.extend({
  props: {
    blok: {
      type: Object,
      required: true,
    } as PropOptions<Faq>,
  },
  data() {
    return {
      selectedCategoryIndex: 0,
      openCategories: {} as Record<number, boolean>,
    };
  },
  methods: {
    toggle(index: number) {
      this.$set(this.openCategories, index, !this.openCategories[index]);
    },
  },
});
